import Tracker from './Tracker';

const todoTracker = new Tracker('todo', {
	DISMISS_OVERDUE: 'dismissOverdue',
	GOTO_OVERDUE: 'goToOverdue',
	NAVIGATE_SIDEBAR: 'navigateSidebar'
});

export default todoTracker;
